'use client'
import { LogLevel, Logger } from '@dynamic-labs/logger';
import { TURNKEY_SDK_BENIGN_ERRORS } from '../../constants.js';

class DynamicEmbeddedWalletsLogger extends Logger {
    constructor(name, level) {
        super(name, level);
    }
    error(message, ...args) {
        const [err] = args;
        if (!(err === null || err === void 0 ? void 0 : err.message) ||
            !TURNKEY_SDK_BENIGN_ERRORS.some((errorMsg) => err.message.includes(errorMsg))) {
            Logger.events.emit('error', message);
            this.log(LogLevel.ERROR, message, ...args);
        }
        else {
            // log benign turnkey sdk errors as WARN
            this.warn(message, ...args);
        }
    }
}
const logger = new DynamicEmbeddedWalletsLogger('Dynamic embedded wallets', LogLevel.INFO);

export { DynamicEmbeddedWalletsLogger, logger };
